// Suggestions are transcribed declarations, never recipe inference or verification.
const ALLERGENS = { gluten: 'Cereali contenenti glutine', crustaceans: 'Crostacei', eggs: 'Uova', fish: 'Pesce', peanuts: 'Arachidi', soy: 'Soia', milk: 'Latte', nuts: 'Frutta a guscio', celery: 'Sedano', mustard: 'Senape', sesame: 'Sesamo', sulphites: 'Anidride solforosa e solfiti', lupin: 'Lupini', molluscs: 'Molluschi' };
const key = value => String(value || '').normalize('NFKC').toLocaleLowerCase('it').trim().replace(/\s+/g,' ');
const aliases = Object.fromEntries(Object.entries(ALLERGENS).map(([id,label])=>[key(label),id]));
Object.assign(aliases, { glutine:'gluten', 'latte e derivati':'milk', 'uova e derivati':'eggs', 'soia e derivati':'soy', solfiti:'sulphites', 'semi di sesamo':'sesame' });
function allergenSuggestions(text, legend = []) {
  if (typeof text !== 'string' || !Array.isArray(legend)) return [];
  // Do not reinterpret absence claims, trace warnings or free-form sentences.
  const tokens = text.replace(/^\s*(?:allergeni|contiene)\s*:?\s*/i,'').split(/[,;\n]+/).map(key).filter(Boolean);
  const result = [];
  for (const token of tokens) {
    let id = Object.hasOwn(aliases,token) ? aliases[token] : null;
    if (!id) {
      const matches = legend.filter(entry => key(entry?.code) === token);
      if (matches.length === 1 && Object.hasOwn(aliases,key(matches[0].label))) id = aliases[key(matches[0].label)];
    }
    // Partial declarations remain manual: never silently drop an unknown symbol.
    if (!id) return [];
    if (!result.includes(id)) result.push(id);
  }
  return result;
}
function reviewPending(menu = []) {
  return menu.map((item,index)=>({item,index})).filter(({item})=>item.verified !== true || item.allergenStatus !== 'declared');
}
module.exports = { ALLERGENS, allergenSuggestions, reviewPending };
